import { Component, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { FunnelService } from '../../features/users/components/funnel/funnel.service';
import { BrandingService } from '../../core/services/branding.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  
  @Input() isLanding: boolean = false;
  brandingId: string = '';
  logoUrl: string = '';
  selectedLang: string = localStorage.getItem('language') || 'es';


  constructor(private router: Router, private funnelService: FunnelService, private brandingService: BrandingService, private translate: TranslateService) {

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;
        this.isLanding = url === '/landing';
      });
  }

  ngOnInit(): void {

    this.brandingId = localStorage.getItem('brandingId') || '';

    // this.funnelService.getBrandingStyles(this.brandingId).subscribe((data) => {
    //   if (data.LogoUrl) {
    //     const img = new Image();
    //     img.src = data.LogoUrl;
    
    //     img.onload = () => {
    //       this.logoUrl = data.LogoUrl;
    //     };
    
    //     img.onerror = () => {
    //       console.error('Error cargando el logo');
    //     };
    //   }
    // });

    this.brandingService.brandingId$.subscribe((brandingId) => {
      if (brandingId) {
        console.log('Branding ID en Header:', brandingId);
      }
    });
  }

  changeLanguage(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const lang = selectElement.value;
    this.translate.use(lang);
    localStorage.setItem('language', lang);
  }

}
